module.exports = __webpack_public_path__ + "img/email.52198676.svg";